import styled from "styled-components";

export const InfoPanelWrapper = styled.div`
  form {
    margin-top: 38px;
  }
  .ant-form-item-label label {
    font-size: 16px;
    font-weight: 400;
    line-height: 150%;
  }

  .shifted-up {
    margin-top: -40px;
  }

  .label {
    font-family: "PoppinsRegular", sans-serif !important;
    font-size: 16px;
    margin-top: 38px;
    margin-bottom: 18px;
  }

  .centered {
    margin-top: -10px;
  }
`;
